import { render } from "./DashboardValuePlayers.vue?vue&type=template&id=172e53f5&scoped=true"
import script from "./DashboardValuePlayers.vue?vue&type=script&lang=js"
export * from "./DashboardValuePlayers.vue?vue&type=script&lang=js"

import "./DashboardValuePlayers.vue?vue&type=style&index=0&id=172e53f5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-172e53f5"]])

export default __exports__